import React from "react";  
import { Checkbox, IconButton, Stack, TextField, Typography } from "@mui/material";
import { StyledAutocompleteInput } from "../../../shared/Components/StyledAutocompleteInput";
import { useTBContext } from "../../Contexts/useTBStates";
import { useState } from "react";
import { useEffect } from "react";
import DeleteIcon from '@mui/icons-material/Delete';


interface SideGameOptionsProps {
    sideGameIndex: number;
}

export const SideGameOptions = ({ sideGameIndex }: SideGameOptionsProps) => {

    const { appTheme, factor, editMode, viewEvent, roundValue, optionsLoaded, setViewEvent } = useTBContext();

    const [sideGame, setSideGame] = useState<any>(null);
    const [sideGameOption, setSideGameOption] = useState<any>([]);

    useEffect(() => {
        const round = viewEvent?.rounds?.[roundValue - 1];
        const sideGameData = round?.sideGames?.[sideGameIndex];
        if (!round?.sideGames) return;
        const sideGameName = sideGameData?.type;
        setSideGame(sideGameData ?? null);
        if (sideGameName !== '') {
            const sideGamesOpt = optionsLoaded?.find((item: any) => item.keyName === 'SideGames') as { options?: Array<{ type: string }> } | undefined;
            if (sideGamesOpt?.options) {
                setSideGameOption(sideGamesOpt.options.filter((item: any) => item.type === sideGameName));
            }
        }
    }, [viewEvent, roundValue, sideGameIndex]);

    const handleSideGameChange = (key: any, value: any) => {
        if (!viewEvent) return;
        const round = viewEvent.rounds?.[roundValue - 1];
        if (!round?.sideGames?.[sideGameIndex]) return;
        round.sideGames[sideGameIndex][key] = value;
        setViewEvent({...viewEvent});
    };

    return (
        <Stack direction={'row'} spacing={1}>

            {sideGame?.type && sideGame?.type !== '' && (

                Object.keys(sideGame).filter((key: any) => !['type', 'name'].includes(key)).map((key: any) => {

                    return (
                        <Stack direction={'column'} spacing={0} width={100*factor} padding={'0px 0px'}
                            sx={{
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            
                            {typeof sideGame[key] === 'boolean' && (
                                <>
                                    <Typography variant='subtitle2' sx={{ fontWeight: 500, textAlign: 'center' }}>
                                        {key.split(/(?=[A-Z])/).map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                    </Typography>
                                    <Checkbox disabled={!editMode} checked={sideGame[key]} onChange={(event) => {
                                        handleSideGameChange(key, event.target.checked);
                                    }}/>
                                </>
                            )}
                            
                            {typeof sideGame[key] === 'number' && (
                                <TextField disabled={!editMode} value={sideGame[key]} variant='outlined'
                                    label={'Game Cost'}
                                    type='number'
                                    onChange={(event) => {
                                        handleSideGameChange(key, Number(event.target.value));
                                    }}
                                    sx={{
                                        padding: 0,
                                        "& .MuiInputBase-input": { fontSize: 12 * (factor ? factor : 1), height: 12 * (factor ? factor : 1), padding: 1 },
                                        '& .MuiOutlinedInput-root': { 
                                            padding: '5px 10px',
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: appTheme.palette.primary.main, // Keep the border green when focused
                                            },  
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: appTheme.palette.primary.main, // Always green outline
                                            },
                                        },
                                        '& input': { textAlign: 'left', lineHeight: 'normal' },
                                      }}
                                    inputProps={{
                                        inputMode: "text",
                                        autoComplete: "off",
                                        sx: {
                                            fontSize: 12 * (factor ? factor : 1),
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: appTheme.palette.primary.main,
                                            },
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { fontSize: 14 * (factor ? factor : 1), lineHeight: 'normal', padding: '0px 10px', backgroundColor: 'white', marginTop: '0px' },
                                        shrink: true
                                    }}
                                />
                            )}
                        </Stack>
                    )
                })
            )}

            <IconButton 
                disabled={!editMode}
                sx={{
                    color: !editMode ? 'gray' : 'primary.main'
                }}
                onClick={() => {
                    if (!viewEvent) return;
                    const round = viewEvent.rounds?.[roundValue - 1];
                    if (!round?.sideGames) return;
                    const newSideGames = JSON.parse(JSON.stringify(round.sideGames));
                    newSideGames.splice(sideGameIndex, 1);
                    const rounds = viewEvent.rounds ?? [];
                    setViewEvent({...viewEvent, rounds: [...rounds.slice(0, roundValue - 1), {...round, sideGames: newSideGames}, ...rounds.slice(roundValue)]});
                }}>
                <DeleteIcon sx={{ color: !editMode ? 'gray' : appTheme.palette.error.main }} />
            </IconButton>

        </Stack>
    )
}